module.exports = __webpack_public_path__ + "media/dorobek/assets/images/comment-c1466570adc4e0a3e292d06d535cf6ba.svg";